import { Parser } from "htmlparser2";

const BLOCK = new Set([
  "p", "div", "br", "li", "ul", "ol", "h1", "h2", "h3", "h4", "h5", "h6", "pre", "blockquote",
  "tr", "table", "hr", "section", "article", "header", "footer", "figure", "dd", "dt",
]);
const SKIP = new Set(["script", "style", "head", "title"]);

/** Plain text of an HTML fragment, used for search and snippets. Blocks become newlines. */
export function htmlToText(html: string): string {
  // Pieces joined once at the end; `last` is the last character written. (Testing `out.endsWith()` on a growing
  // string flattened it at every block: 274 ms for a 244 KB note, ~8 ms this way.)
  const parts: string[] = [];
  let last = "";
  const add = (t: string) => {
    if (!t) return;
    parts.push(t);
    last = t[t.length - 1]!;
  };
  const newline = () => {
    if (last && last !== "\n") add("\n");
  };
  let skip = 0;
  const parser = new Parser(
    {
      onopentag(name) {
        if (SKIP.has(name)) skip++;
        else if (BLOCK.has(name)) newline();
        if (name === "td" || name === "th") add(" ");
      },
      ontext(text) {
        if (!skip) add(text);
      },
      onclosetag(name) {
        if (SKIP.has(name)) skip--;
        else if (BLOCK.has(name)) newline();
      },
    },
    { decodeEntities: true, lowerCaseTags: true },
  );
  parser.write(html);
  parser.end();
  return parts
    .join("")
    .replace(/ /g, " ")
    .replace(/[ \t]+/g, " ")
    .replace(/ ?\n ?/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/** First ~n chars of text on one line, for note-list snippets. */
export function snippet(text: string, n = 200): string {
  const s = text.replace(/\s+/g, " ").trim();
  return s.length > n ? s.slice(0, n) : s;
}
